import React from "react"
import { api, firestore } from "../../core"
import { useForm } from "react-hook-form"
import { User } from "firebase/auth"
import { useFollower } from "popopo-lib-front/firestore-access"
import { UserId } from "popopo-msg"

export const UserFollowForm = (props: { firebase: User; userId: UserId }) => {
  const form = useForm<{ userId: string }>({
    mode: "onBlur",
  })
  const { isSubmitting } = form.formState

  const isFollowing = useFollower(firestore, props.userId, UserId(props.firebase.uid))
  const isFollowed = useFollower(firestore, UserId(props.firebase.uid), props.userId)

  const onFollow = async () => {
    try {
      const idToken = await props.firebase.getIdToken()
      return await api.POST(`/api/v2/users/{user_id}/followers`, {
        params: { path: { user_id: props.userId } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (message) {
      return console.error(message)
    }
  }

  const onUnfollow = async () => {
    try {
      const idToken = await props.firebase.getIdToken()
      return await api.DELETE(`/api/v2/users/{user_id}/followers/me`, {
        params: { path: { user_id: props.userId } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (message) {
      return console.error(message)
    }
  }

  return (
    <>
      <form className="d-flex flex-column gap-3 w-100">
        <ul>
          <li>フォロー状態: {isFollowing === "loading" ? "読み込み中..." : isFollowing === null ? "フォローしていません。" : `フォローしています: ${isFollowing.id}`}</li>
          <li>被フォロー状態: {isFollowed === "loading" ? "読み込み中..." : isFollowed === null ? "フォローされていません。" : `フォローされています: ${isFollowed.id}`}</li>
        </ul>

        <button type="button" className="btn btn-primary form-control" disabled={isSubmitting} onClick={form.handleSubmit(onFollow)}>
          Follow
        </button>

        <button type="button" className="btn btn-warning form-control" disabled={isSubmitting} onClick={form.handleSubmit(onUnfollow)}>
          Unfollow
        </button>
      </form>
    </>
  )
}
